import React, { useEffect, useState, useRef } from 'react';
import { ChevronLeft, ChevronRight, MapPin, Calendar as CalendarIcon, ExternalLink, Trophy, Mountain, Snowflake, X, Clock, CheckCircle2, AlertCircle, UserPlus } from 'lucide-react';
type SportType = 'alpinism' | 'climbing' | 'ice-climbing';
type EventStatus = 'upcoming' | 'registration-open' | 'registration-closed' | 'completed';
interface CompetitionEvent {
  id: string;
  title: string;
  date: Date;
  endDate?: Date;
  location: string;
  type: SportType;
  description: string;
  url: string;
  status: EventStatus;
  registered?: boolean;
}
const EVENTS: CompetitionEvent[] = [{
  id: '1',
  title: 'Кубок України з боулдерингу',
  date: new Date(2026, 1, 7),
  endDate: new Date(2026, 1, 8),
  location: 'Київ, скеледром "Space"',
  type: 'climbing',
  description: 'Перший етап Кубку України. Категорії: чоловіки, жінки, юніори. Відбір до національної збірної.',
  url: '#',
  status: 'registration-open'
}, {
  id: '2',
  title: 'Зимовий кубок з льодолазіння',
  date: new Date(2026, 1, 14),
  endDate: new Date(2026, 1, 15),
  location: 'Карпати, Яремче',
  type: 'ice-climbing',
  description: 'Традиційні зимові змагання на природному льоді. Дисципліни: трудність та швидкість.',
  url: '#',
  status: 'registration-open'
}, {
  id: '3',
  title: "Кубок пам'яті Євгена Білошицького",
  date: new Date(2026, 1, 21),
  location: 'Карпати, г. Говерла',
  type: 'alpinism',
  description: "Традиційне зимове сходження та змагання з техніки альпінізму. Пам'яті видатного українського альпініста.",
  url: '#',
  status: 'upcoming'
}, {
  id: '4',
  title: 'Чемпіонат України зі скелелазіння (трудність)',
  date: new Date(2026, 2, 14),
  endDate: new Date(2026, 2, 15),
  location: 'Львів, "The Wall"',
  type: 'climbing',
  description: 'Головний старт сезону з лазіння на трудність. Відбір до збірної для участі у міжнародних змаганнях.',
  url: '#',
  status: 'upcoming'
}, {
  id: '5',
  title: 'Відкритий чемпіонат Харкова',
  date: new Date(2026, 2, 28),
  endDate: new Date(2026, 2, 29),
  location: 'Харків, скеледром "Вертикаль"',
  type: 'climbing',
  description: 'Відкриті змагання для всіх категорій. Боулдеринг та трудність. Призовий фонд 50 000 грн.',
  url: '#',
  status: 'upcoming',
  registered: true
}, {
  id: '6',
  title: 'Весняна школа альпінізму',
  date: new Date(2026, 3, 11),
  endDate: new Date(2026, 3, 18),
  location: 'Закарпаття, Чорногора',
  type: 'alpinism',
  description: 'Навчально-тренувальний збір для початківців та розрядників. Програма: базові техніки, страховка, орієнтування.',
  url: '#',
  status: 'upcoming'
}, {
  id: '7',
  title: 'Кубок федерації зі скелелазіння',
  date: new Date(2026, 4, 9),
  endDate: new Date(2026, 4, 10),
  location: 'Київ, скеледром "Жовтень"',
  type: 'climbing',
  description: 'Другий етап Кубку Федерації. Боулдеринг. Відкрита реєстрація для всіх членів федерації.',
  url: '#',
  status: 'upcoming'
}, {
  id: '8',
  title: 'Чемпіонат України з альпінізму',
  date: new Date(2026, 5, 20),
  endDate: new Date(2026, 5, 27),
  location: 'Кавказ, Ельбрус',
  type: 'alpinism',
  description: 'Головний старт сезону з альпінізму. Клас: технічні маршрути 5Б–6А. Командний залік.',
  url: '#',
  status: 'upcoming'
}, {
  id: '9',
  title: 'Літній фестиваль скелелазіння',
  date: new Date(2026, 6, 4),
  endDate: new Date(2026, 6, 5),
  location: 'Крим, Нікіта (скелі)',
  type: 'climbing',
  description: 'Щорічний фестиваль на відкритих скелях. Змагання, майстер-класи, кемпінг. Сімейний формат.',
  url: '#',
  status: 'upcoming'
}, {
  id: '10',
  title: 'Кубок України зі швидкісного лазіння',
  date: new Date(2026, 8, 12),
  endDate: new Date(2026, 8, 13),
  location: 'Дніпро, скеледром "Олімп"',
  type: 'climbing',
  description: 'Фінальний етап Кубку України зі швидкісного лазіння. Кваліфікація та фінали.',
  url: '#',
  status: 'upcoming'
}, {
  id: '11',
  title: 'Осінній кубок з альпінізму',
  date: new Date(2026, 9, 3),
  endDate: new Date(2026, 9, 4),
  location: 'Закарпаття, Свидовець',
  type: 'alpinism',
  description: 'Змагання з техніки гірського туризму та альпінізму. Осінній сезон, маршрути 3А–4Б.',
  url: '#',
  status: 'upcoming'
}, {
  id: '12',
  title: 'Чемпіонат України з льодолазіння',
  date: new Date(2026, 11, 5),
  endDate: new Date(2026, 11, 6),
  location: 'Івано-Франківськ, льододром',
  type: 'ice-climbing',
  description: 'Головний старт зимового сезону. Дисципліни: трудність, швидкість, дуель. Відбір на Чемпіонат світу UIAA.',
  url: '#',
  status: 'upcoming'
}];
const SPORT_CONFIG: Record<SportType, {
  label: string;
  color: string;
  bg: string;
  border: string;
  icon: React.ElementType;
}> = {
  alpinism: {
    label: 'Альпінізм',
    color: '#3b8fd4',
    bg: '#eff8ff',
    border: '#bfdbf7',
    icon: Mountain
  },
  climbing: {
    label: 'Скeлелазіння',
    color: '#16a34a',
    bg: '#f0fdf4',
    border: '#bbf7d0',
    icon: Trophy
  },
  'ice-climbing': {
    label: 'Льодолазіння',
    color: '#0891b2',
    bg: '#ecfeff',
    border: '#a5f3fc',
    icon: Snowflake
  }
};
const STATUS_CONFIG: Record<EventStatus, {
  label: string;
  color: string;
  bg: string;
  icon: React.ElementType;
}> = {
  upcoming: {
    label: 'Очікується',
    color: '#64748b',
    bg: '#f1f5f9',
    icon: Clock
  },
  'registration-open': {
    label: 'Реєстрація відкрита',
    color: '#16a34a',
    bg: '#f0fdf4',
    icon: CheckCircle2
  },
  'registration-closed': {
    label: 'Реєстрація закрита',
    color: '#ea580c',
    bg: '#fff7ed',
    icon: AlertCircle
  },
  completed: {
    label: 'Завершено',
    color: '#94a3b8',
    bg: '#f8fafc',
    icon: CheckCircle2
  }
};
const MONTH_NAMES = ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'];
const WEEKDAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];
export function CompetitionsPage() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedType, setSelectedType] = useState<SportType | 'all'>('all');
  const [activeTooltip, setActiveTooltip] = useState<string | null>(null);
  const [registrationEventId, setRegistrationEventId] = useState<string | null>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  // Close tooltip on outside click
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target as Node)) {
        setActiveTooltip(null);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);
  const prevMonth = () => setCurrentDate(new Date(year, month - 1, 1));
  const nextMonth = () => setCurrentDate(new Date(year, month + 1, 1));
  const goToday = () => setCurrentDate(new Date());
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  // Monday-based: Sunday=6, Mon=0
  const rawFirst = new Date(year, month, 1).getDay();
  const firstDay = rawFirst === 0 ? 6 : rawFirst - 1;
  const totalCells = Math.ceil((daysInMonth + firstDay) / 7) * 7;
  const filteredEvents = EVENTS.filter(e => selectedType === 'all' || e.type === selectedType);
  const getEventsForDay = (day: number): CompetitionEvent[] => {
    const dayStart = new Date(year, month, day);
    const dayEnd = new Date(year, month, day, 23, 59, 59);
    return filteredEvents.filter(e => {
      const end = e.endDate ?? e.date;
      return dayStart <= end && dayEnd >= e.date;
    });
  };
  const today = new Date();
  const isToday = (day: number) => day === today.getDate() && month === today.getMonth() && year === today.getFullYear();
  // Upcoming events: future events sorted by date
  const upcomingEvents = EVENTS.filter(e => e.status !== 'completed' && e.date >= new Date(today.getFullYear(), today.getMonth(), today.getDate())).sort((a, b) => a.date.getTime() - b.date.getTime()).slice(0, 5);
  const formatDate = (date: Date, endDate?: Date) => {
    const opts: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long'
    };
    const start = date.toLocaleDateString('uk-UA', opts);
    if (!endDate) return start;
    return `${start} — ${endDate.toLocaleDateString('uk-UA', opts)}`;
  };
  const handleRegister = (eventId: string) => {
    setRegistrationEventId(eventId);
  };
  const confirmRegistration = () => {
    // Тут буде логіка реєстрації
    console.log('Реєстрація на подію:', registrationEventId);
    setRegistrationEventId(null);
  };
  const cancelRegistration = () => {
    setRegistrationEventId(null);
  };
  const registrationEvent = EVENTS.find(e => e.id === registrationEventId);
  return <div className="space-y-6" data-id="element-36">
      {/* Page header */}
      <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-slate-100" data-id="element-37">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-38">
          <div data-id="element-39">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-40">Календар подій</h2>
            <p className="text-sm text-slate-500 mt-0.5" data-id="element-41">
              Офіційні заходи Федерації Альпінізму та Скeлелазіння України
            </p>
          </div>
          {/* Category filters */}
          <div className="flex flex-wrap gap-2" data-id="element-42">
            {(['all', 'alpinism', 'climbing', 'ice-climbing'] as const).map(type => {
            const isAll = type === 'all';
            const cfg = isAll ? null : SPORT_CONFIG[type];
            const isActive = selectedType === type;
            return <button key={type} onClick={() => setSelectedType(type)} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium border transition-all" style={isActive ? {
              background: 'linear-gradient(135deg, #3b8fd4, #1d6fa8)',
              color: '#fff',
              borderColor: '#1d6fa8'
            } : {
              backgroundColor: '#f8fafc',
              color: '#475569',
              borderColor: '#e2e8f0'
            }} data-id="element-43">
                    {cfg && <span className="w-2 h-2 rounded-full" style={{
                backgroundColor: cfg.color
              }} data-id="element-44" />}
                    {isAll ? 'Всі події' : cfg!.label}
                  </button>;
          })}
          </div>
        </div>
      </div>

      {/* Calendar */}
      <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-slate-100 overflow-hidden" data-id="element-45">
        {/* Calendar nav */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100" data-id="element-46">
          <button onClick={prevMonth} className="p-2 rounded-lg hover:bg-slate-100 text-slate-500 transition-colors" data-id="element-47">
            <ChevronLeft className="w-5 h-5" data-id="element-48" />
          </button>
          <div className="flex items-center gap-3" data-id="element-49">
            <h3 className="text-lg font-bold text-slate-900" data-id="element-50">
              {MONTH_NAMES[month]} {year}
            </h3>
            <button onClick={goToday} className="px-3 py-1 text-xs font-medium rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors" data-id="element-51">
              Сьогодні
            </button>
          </div>
          <button onClick={nextMonth} className="p-2 rounded-lg hover:bg-slate-100 text-slate-500 transition-colors" data-id="element-52">
            <ChevronRight className="w-5 h-5" data-id="element-53" />
          </button>
        </div>

        {/* Weekday headers */}
        <div className="grid grid-cols-7 bg-slate-50/60 border-b border-slate-100" data-id="element-54">
          {WEEKDAYS.map((d, i) => <div key={d} className={`py-2.5 text-center text-xs font-semibold uppercase tracking-wider ${i >= 5 ? 'text-slate-400' : 'text-slate-500'}`} data-id="element-55">
              {d}
            </div>)}
        </div>

        {/* Days grid */}
        <div className="grid grid-cols-7" ref={tooltipRef} data-id="element-56">
          {Array.from({
          length: totalCells
        }).map((_, idx) => {
          const day = idx - firstDay + 1;
          const isCurrentMonth = day >= 1 && day <= daysInMonth;
          const dayEvents = isCurrentMonth ? getEventsForDay(day) : [];
          const isWeekend = idx % 7 >= 5;
          const todayCell = isCurrentMonth && isToday(day);
          const isRightHalf = idx % 7 >= 4;
          return <div key={idx} className={`min-h-[90px] sm:min-h-[110px] p-1.5 sm:p-2 border-b border-r border-slate-50 relative ${!isCurrentMonth ? 'bg-slate-50/40' : isWeekend ? 'bg-slate-50/20' : ''} ${todayCell ? 'bg-blue-50/30' : ''}`} data-id="element-57">
                {isCurrentMonth && <>
                    <span className={`inline-flex w-6 h-6 sm:w-7 sm:h-7 items-center justify-center rounded-full text-xs sm:text-sm font-medium mb-1 ${todayCell ? 'bg-blue-600 text-white shadow-sm' : isWeekend ? 'text-slate-400' : 'text-slate-700'}`} data-id="element-58">
                      {day}
                    </span>
                    <div className="space-y-0.5" data-id="element-59">
                      {dayEvents.slice(0, 2).map(event => {
                  const cfg = SPORT_CONFIG[event.type];
                  const isOpen = activeTooltip === event.id;
                  return <div key={event.id} className="relative" data-id="element-60">
                            <button onClick={e => {
                      e.stopPropagation();
                      setActiveTooltip(isOpen ? null : event.id);
                    }} className="w-full text-left px-1.5 py-0.5 rounded text-[10px] font-medium truncate border transition-all hover:opacity-80" style={{
                      backgroundColor: cfg.bg,
                      color: cfg.color,
                      borderColor: cfg.border
                    }} data-id="element-61">
                              <span className="hidden sm:inline" data-id="element-62">
                                {event.title}
                              </span>
                              <span className="sm:hidden w-2 h-2 rounded-full inline-block" style={{
                        backgroundColor: cfg.color
                      }} data-id="element-63" />
                            </button>

                            {/* Tooltip */}
                            {isOpen && <div className={`absolute z-50 top-full mt-1 w-[260px] sm:w-[300px] bg-white rounded-xl border border-slate-100 p-4 text-left ${isRightHalf ? 'right-0' : 'left-0'}`} style={{
                      boxShadow: '0 8px 32px rgba(0,0,0,0.14)'
                    }} onClick={e => e.stopPropagation()} data-id="element-64">
                                <div className="flex items-start justify-between gap-2 mb-3" data-id="element-65">
                                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide border" style={{
                          backgroundColor: cfg.bg,
                          color: cfg.color,
                          borderColor: cfg.border
                        }} data-id="element-66">
                                    {cfg.label}
                                  </span>
                                  <button onClick={() => setActiveTooltip(null)} className="text-slate-400 hover:text-slate-600 transition-colors flex-shrink-0" data-id="element-67">
                                    <X className="w-3.5 h-3.5" data-id="element-68" />
                                  </button>
                                </div>

                                <h4 className="font-bold text-slate-900 text-sm leading-tight mb-2" data-id="element-69">
                                  {event.title}
                                </h4>

                                <div className="space-y-1.5 mb-3" data-id="element-70">
                                  <div className="flex items-center gap-1.5 text-xs text-slate-500" data-id="element-71">
                                    <CalendarIcon className="w-3.5 h-3.5 flex-shrink-0" data-id="element-72" />
                                    {formatDate(event.date, event.endDate)}
                                  </div>
                                  <div className="flex items-center gap-1.5 text-xs text-slate-500" data-id="element-73">
                                    <MapPin className="w-3.5 h-3.5 flex-shrink-0" data-id="element-74" />
                                    {event.location}
                                  </div>
                                </div>

                                <p className="text-xs text-slate-600 leading-relaxed mb-3 pb-3 border-b border-slate-50" data-id="element-75">
                                  {event.description}
                                </p>

                                <div className="flex items-center justify-between" data-id="element-76">
                                  {(() => {
                          const s = STATUS_CONFIG[event.status];
                          const SIcon = s.icon;
                          return <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium" style={{
                            backgroundColor: s.bg,
                            color: s.color
                          }} data-id="element-77">
                                        <SIcon className="w-3 h-3" data-id="element-78" />
                                        {s.label}
                                      </span>;
                        })()}
                                  <a href={event.url} className="inline-flex items-center gap-1 text-xs font-semibold hover:underline" style={{
                          color: cfg.color
                        }} data-id="element-79">
                                    Детальніше
                                    <ExternalLink className="w-3 h-3" data-id="element-80" />
                                  </a>
                                </div>
                              </div>}
                          </div>;
                })}
                      {dayEvents.length > 2 && <span className="text-[10px] text-slate-400 font-medium pl-1" data-id="element-81">
                          +{dayEvents.length - 2} ще
                        </span>}
                    </div>
                  </>}
              </div>;
        })}
        </div>

        {/* Legend */}
        <div className="px-6 py-3 border-t border-slate-50 bg-slate-50/30 flex flex-wrap gap-4" data-id="element-82">
          {(Object.entries(SPORT_CONFIG) as [SportType, (typeof SPORT_CONFIG)[SportType]][]).map(([key, cfg]) => <div key={key} className="flex items-center gap-1.5 text-xs text-slate-500" data-id="element-83">
              <span className="w-2.5 h-2.5 rounded-full" style={{
            backgroundColor: cfg.color
          }} data-id="element-84" />
              {cfg.label}
            </div>)}
        </div>
      </div>

      {/* Upcoming events list */}
      <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-slate-100 overflow-hidden" data-id="element-85">
        <div className="px-6 py-4 border-b border-slate-100 flex items-center gap-3" data-id="element-86">
          <div className="w-9 h-9 rounded-xl bg-slate-50 flex items-center justify-center" data-id="element-87">
            <Trophy className="w-4 h-4 text-slate-500" data-id="element-88" />
          </div>
          <div data-id="element-89">
            <h3 className="font-bold text-slate-900" data-id="element-90">Найближчі змагання</h3>
            <p className="text-xs text-slate-500" data-id="element-91">Актуальні події федерації</p>
          </div>
        </div>

        {upcomingEvents.length === 0 ? <div className="py-12 text-center text-slate-400 text-sm" data-id="element-92">
            Найближчих подій не заплановано
          </div> : <div className="divide-y divide-slate-50" data-id="element-93">
            {upcomingEvents.map(event => {
          const cfg = SPORT_CONFIG[event.type];
          const s = STATUS_CONFIG[event.status];
          const SIcon = s.icon;
          return <div key={event.id} className="flex items-center gap-4 px-6 py-4 hover:bg-slate-50/50 transition-colors group" data-id="element-94">
                  {/* Date badge */}
                  <div className="flex-shrink-0 w-12 text-center" data-id="element-95">
                    <div className="text-lg font-bold text-slate-900 leading-none" data-id="element-96">
                      {event.date.getDate()}
                    </div>
                    <div className="text-[10px] font-medium text-slate-400 uppercase mt-0.5" data-id="element-97">
                      {MONTH_NAMES[event.date.getMonth()].slice(0, 3)}
                    </div>
                  </div>

                  {/* Divider */}
                  <div className="w-px h-10 bg-slate-100 flex-shrink-0" data-id="element-98" />

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-99">
                    <div className="flex items-center gap-2 mb-0.5" data-id="element-100">
                      <span className="text-[10px] font-bold uppercase tracking-wide" style={{
                  color: cfg.color
                }} data-id="element-101">
                        {cfg.label}
                      </span>
                    </div>
                    <p className="text-sm font-semibold text-slate-800 truncate" data-id="element-102">
                      {event.title}
                    </p>
                    <div className="flex items-center gap-1 mt-0.5" data-id="element-103">
                      <MapPin className="w-3 h-3 text-slate-400 flex-shrink-0" data-id="element-104" />
                      <span className="text-xs text-slate-500 truncate" data-id="element-105">
                        {event.location}
                      </span>
                    </div>
                  </div>

                  {/* Status + actions */}
                  <div className="flex items-center gap-2 flex-shrink-0" data-id="element-106">
                    <span className="hidden sm:inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium" style={{
                backgroundColor: s.bg,
                color: s.color
              }} data-id="element-107">
                      <SIcon className="w-3 h-3" data-id="element-108" />
                      {s.label}
                    </span>
                    {(event.status === 'registration-open' || event.status === 'upcoming') && (event.registered ? <div className="p-2 rounded-lg text-slate-300 cursor-default" title="Зареєстровано" data-id="element-109">
                          <CheckCircle2 className="w-4 h-4" data-id="element-110" />
                        </div> : <button onClick={() => handleRegister(event.id)} className="p-2 rounded-lg text-slate-400 hover:text-blue-600 hover:bg-blue-50 transition-colors" title="Зареєструватись на подію" data-id="element-111">
                          <UserPlus className="w-4 h-4" data-id="element-112" />
                        </button>)}
                    <a href={event.url} className="p-2 rounded-lg text-slate-400 hover:text-blue-600 hover:bg-blue-50 transition-colors" title="Детальніше" data-id="element-113">
                      <ExternalLink className="w-4 h-4" data-id="element-114" />
                    </a>
                  </div>
                </div>;
        })}
          </div>}
      </div>

      {/* Registration Confirmation Modal */}
      {registrationEventId && registrationEvent && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }} onClick={cancelRegistration} data-id="element-115">
          <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-116">
            {/* Header */}
            <div className="flex items-start justify-between mb-4" data-id="element-117">
              <div className="flex items-center gap-3" data-id="element-118">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{
              backgroundColor: '#eff8ff'
            }} data-id="element-119">
                  <UserPlus className="w-5 h-5" style={{
                color: '#3b8fd4'
              }} data-id="element-120" />
                </div>
                <div data-id="element-121">
                  <h3 className="font-bold text-slate-900 text-lg" data-id="element-122">
                    Підтвердження реєстрації
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-123">
                    Перевірте деталі перед реєстрацією
                  </p>
                </div>
              </div>
              <button onClick={cancelRegistration} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-124">
                <X className="w-5 h-5" data-id="element-125" />
              </button>
            </div>

            {/* Event Details */}
            <div className="p-4 rounded-xl mb-5" style={{
          backgroundColor: '#f8fafc'
        }} data-id="element-126">
              <h4 className="font-semibold text-slate-900 mb-3" data-id="element-127">
                {registrationEvent.title}
              </h4>
              <div className="space-y-2" data-id="element-128">
                <div className="flex items-center gap-2 text-sm text-slate-600" data-id="element-129">
                  <CalendarIcon className="w-4 h-4 text-slate-400" data-id="element-130" />
                  {formatDate(registrationEvent.date, registrationEvent.endDate)}
                </div>
                <div className="flex items-center gap-2 text-sm text-slate-600" data-id="element-131">
                  <MapPin className="w-4 h-4 text-slate-400" data-id="element-132" />
                  {registrationEvent.location}
                </div>
              </div>
            </div>

            {/* Confirmation Message */}
            <p className="text-sm text-slate-600 mb-6" data-id="element-133">
              Ви дійсно бажаєте зареєструватись на цю подію? Після підтвердження
              ви отримаєте деталі на вашу електронну пошту.
            </p>

            {/* Actions */}
            <div className="flex items-center gap-3" data-id="element-134">
              <button onClick={confirmRegistration} className="flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl text-white font-semibold text-sm transition-all hover:opacity-90" style={{
            background: 'linear-gradient(135deg, #3b8fd4, #1d6fa8)'
          }} data-id="element-135">
                <CheckCircle2 className="w-4 h-4" data-id="element-136" />
                Підтвердити реєстрацію
              </button>
              <button onClick={cancelRegistration} className="px-4 py-3 rounded-xl text-sm font-medium text-slate-600 border border-slate-200 bg-slate-50 hover:bg-slate-100 transition-colors" data-id="element-137">
                Скасувати
              </button>
            </div>
          </div>
        </div>}
    </div>;
}